import { gql } from "@apollo/client";

export const OFFER_ADDITIONAL_DATA_UPDATED = gql`
  subscription OfferAdditionalDataUpdated($documentId: Int!, $siteId: Int!) {
    offerAdditionalDataUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;


export const OFFER_ADDITIONAL_DATA_INVALIDATED = gql`
  subscription offerAdditionalDataInvalidated($documentId: Int!, $siteId: Int!) {
    offerAdditionalDataInvalidated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;


export const OFFER_CLIENT_FACILITIES_RETRIEVED = gql`
  subscription OfferClientFacilitiesRetrieved($documentId: Int!, $siteId: Int!) {
    offerClientFacilitiesRetrieved(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      facilityList {
        chDocumentId
        chSiteId
        documentNumber
      }
    }
  }
`;

export const VARIABLE_INTEREST_COMPUTED = gql`
  subscription VariableInterestComputed($documentId: Int!, $siteId: Int!) {
    variableInterestComputed(documentId: $documentId, siteId: $siteId) {
      variableInterest
      variableInterestDate
    }
  }
`;
